import React from "react";
import { ApiUserAvatar } from "src/api/types";
import Avatar, { AvatarSize } from "src/components/Avatar";

interface UserAvatarsProps {
	users: ApiUserAvatar[];
	overlay?: React.ReactElement;
	avatar?: {
		size: AvatarSize;
	};
}

const UserAvatars = ({ users, overlay, avatar }: UserAvatarsProps) => {
	return (
		<div className="flex">
			{users.map((user, index) => (
				<div
					style={{ zIndex: users.length - index }}
					className={index !== 0 ? "-ml-2 relative" : "relative"}
					key={`user-${user.hid}`}
				>
					{index === 0 && overlay}
					<Avatar
						size="small"
						src={user.avatar}
						alt={user.full_name}
						{...avatar}
					/>
				</div>
			))}
		</div>
	);
};

const Loading = () => {
	return (
		<div className="flex">
			{new Array(3).fill("").map((_, index) => (
				<div
					style={{ zIndex: 4 - index }}
					className={`${
						index !== 0 ? "-ml-2 relative" : "relative"
					} border-2 border-white rounded-md`}
					key={`user-${index}-loading`}
				>
					<Avatar.Loader size="small" />
				</div>
			))}
		</div>
	);
};

UserAvatars.Loading = Loading;

export default UserAvatars;
